module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['edmodo-footer', _vm.isLoading ? 'isLoading' : 'isLoaded']
  }, [_c('footer', {
    staticClass: "fusion-footer-widget-area fusion-widget-area"
  }, [_c('div', {
    staticClass: "fusion-row"
  }, [_c('lang'), _vm._v(" "), _c('div', {
    staticClass: "footer-links"
  }, _vm._l((_vm.columns), function(column, index) {
    return _c('column', {
      key: index,
      attrs: {
        "title": column.title,
        "links": column.links
      }
    })
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f86bfb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edmodo/footer.vue
// module id = 466
// module chunks = 9